import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { GetKey } from "../../../Finanzas/Actions/GetContainer";
import { useBox } from "../../../Finanzas/Helper/useBox";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import request from "../../../../Helpers/API";
import { FormatMiles, FormatMoney } from "../../../../Helpers/FormatNumber";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CommentIcon from "@mui/icons-material/Comment";

import EditIcon from "@mui/icons-material/Edit";
import FiltroInventarioRotacion from "./FiltroInventarioRotacion";

export const InventarioRotacionMainScreen = () => {
  const history = useHistory();
  const location = useLocation();
  const [boxstate, setBoxState] = useBox();
  const [inventario, setInventario] = useState();
  const [totales, setTotales] = useState();
  const [rotacion, setRotacion] = useState();
  const storedState =
    JSON.parse(localStorage.getItem("dashboard_filtro")) || {};

  const [titulo, setTitulo] = useState("ROTACION DE INVENTARIO");

  const meses = [
    "ENERO",
    "FEBRERO",
    "MARZO",
    "ABRIL",
    "MAYO",
    "JUNIO",
    "JULIO",
    "AGOSTO",
    "SEPTIEMBRE",
    "OCTUBRE",
    "NOVIEMBRE",
    "DICIEMBRE",
  ];

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  useEffect(() => {
    const today = new Date();
    let currentMonth = today.getMonth() + 1;
    let currentYear = today.getFullYear();
    if (storedState && Object.keys(storedState).length > 0) {
      currentMonth = storedState.periodofin;
      currentYear = storedState.ejercicio;
    }

    onExecute(currentYear, currentMonth);
  }, []);

  const onExecute = (ejercicio, periodo) => {
    setLoader({ ...loader, mostrar: true });
    var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    var adr = GetKey(boxstate.pv.adr, ["idadr"]);

    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = "0";
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }

    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `RotacionInventario/Reporte?ejercicio=${ejercicio}&periodo=${periodo}&adr=${adr}&sucursales=${sucursales}`,
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });

          const filasBody = result.filter(
            (item) =>
              item.linea !== "TOTALES" && item.linea !== "ROTACION TOTAL",
          );

          const totales = result.find((item) => item.linea === "TOTALES");
          const rotacionTotal = result.find(
            (item) => item.linea === "ROTACION TOTAL",
          );

          setInventario(filasBody);
          setTotales(totales);
          setRotacion(rotacionTotal);

          const mesFinalIndex = periodo - 1; // periodo: 1–12
          const mesFinal = meses[mesFinalIndex];
          const anioFinal = ejercicio;

          const mesInicialIndex = (mesFinalIndex + 1) % 12;
          const mesInicial = meses[mesInicialIndex];
          const anioInicial = ejercicio - 1;

          const tituloP = `ROTACION DE INVENTARIOS ${mesInicial} ${anioInicial} - ${mesFinal} ${anioFinal}`;

          setTitulo(tituloP);

          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };

  const onRegresar = (estatus, motivo) => {
    history.push("/Finanzas/Main");
  };

  const onGeneraExcel = () => {
    var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = "0";
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }

    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `RotacionInventario/ImprimirExcelReporte?ejercicio=${Number(boxstate.ejercicioinicio)}&periodo=${Number(boxstate.periodoinicio)}&adr=${adr}&sucursales=${sucursales}`,
      )
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
      });
  };

  return (
    <PlantillaScreen
      titulo={titulo}
      className={"inventario-rotacion-main-screen"}
      className_main={2}
    >
      <LoaderScreen loader={loader} />

      <div className="reporte-recuperacion-responsable-actions">
        <div
          className="reporte-recuperacion-responsable-actions-regresar"
          onClick={() => onRegresar()}
        >
          <ArrowBackIcon /> Regresar
        </div>
        <div className="reporte-recuperacion-responsable-actions-filtro">
          <FiltroInventarioRotacion
            onExecute={onExecute}
            boxState={boxstate}
            onBoxChange={setBoxState}
            ejercicio={storedState.ejercicio}
            periodo_inicio={storedState.periodofin}
          />
        </div>
        <div className="buttons">
          <button className="excel" onClick={() => onGeneraExcel()}>
            <i className=" icon-file-excel" /> Excel
          </button>
        </div>
      </div>
      <div className="rcxc-miles">(Cifras expresadas en miles de pesos)</div>
      {inventario && inventario.length > 0 && (
        <div className="inventario-rotacion-main-container">
          <div className="inventario-rotacion-tabla-container scroll">
            <table cellPadding={0} cellSpacing={0}>
              <thead>
                <tr>
                  <th>Linea</th>
                  <th>
                    <div>Minimo</div>
                  </th>
                  <th>
                    <div>Maximo</div>
                  </th>
                  <th>
                    <div>Venta</div>
                  </th>
                  <th>
                    <div>Costo</div>
                  </th>
                  <th>
                    <div>Optimo Maximo</div>
                  </th>
                  <th>
                    <div>Optimo Minimo</div>
                  </th>
                  <th>
                    <div>Inventario Promedio 12 Meses</div>
                  </th>
                  <th>
                    <div>Diferencia Maxima 12 Meses</div>
                  </th>
                  <th>
                    <div>Diferencia Minima 12 Meses</div>
                  </th>
                  <th>
                    <div>Rotacion</div>
                  </th>
                  <th>
                    <div>Dias en inventario</div>
                  </th>
                  <th>
                    <div>Inventario Mes</div>
                  </th>
                  <th>
                    <div>Diferencia Maxima Mes</div>
                  </th>
                  <th>
                    <div>Diferencia Minima Mes</div>
                  </th>
                  {/* <th>
                                        <div>Rotacion Mes</div>
                                    </th> */}
                </tr>
              </thead>
              <tbody>
                {/* Usar map para renderizar las filas de la tabla */}
                {inventario.map((item, index) => (
                  <tr>
                    <td className="celda-vendedor">
                      {capitalizePalabras(item.linea)}
                    </td>
                    <td className="ta-center">{item.minimo}</td>
                    <td className="ta-center">{item.maximo}</td>
                    <td className="ta-right">{FormatMiles(item.venta, 0)}</td>
                    <td className="ta-right">{FormatMiles(item.costo, 0)}</td>
                    <td className="ta-right">
                      {FormatMiles(item.opt_maximo, 0)}
                    </td>
                    <td className="ta-right">
                      {FormatMiles(item.opt_minimo, 0)}
                    </td>
                    <td className="ta-right">
                      {FormatMiles(item.inventario, 0)}
                    </td>
                    <td className="ta-right">
                      {FormatMiles(item.dif_maxima, 0)}
                    </td>
                    <td className="ta-right">
                      {FormatMiles(item.dif_minima, 0)}
                    </td>
                    <td className="ta-center">
                      {FormatMoney(item.rotacion, 2)}
                    </td>
                    <td className="ta-center">
                      {FormatMoney(item.dias_inventario, 2)}
                    </td>
                    <td className="ta-right">
                      {FormatMiles(item.inventariomes, 0)}
                    </td>
                    <td className="ta-right">
                      {FormatMiles(item.dif_maxima_mes, 0)}
                    </td>
                    <td className="ta-right">
                      {FormatMiles(item.dif_minima_mes, 0)}
                    </td>
                    {/* <td className="ta-center">{FormatMiles(item.rotacionmes, 2)}</td> */}
                  </tr>
                ))}
              </tbody>
              <tfoot>
                {totales && (
                  <tr>
                    <td className="celda-vendedor">
                      {capitalizePalabras(totales.linea)}
                    </td>
                    <td className="ta-center">
                      {totales.minimo === 0 ? "" : totales.minimo}
                    </td>
                    <td className="ta-center">
                      {totales.maximo === 0 ? "" : totales.maximo}
                    </td>
                    <td className="ta-right">
                      {FormatMiles(totales.venta, 0)}
                    </td>
                    <td className="ta-right">
                      {FormatMiles(totales.costo, 0)}
                    </td>
                    <td className="ta-right">
                      {FormatMiles(totales.opt_maximo, 0)}
                    </td>
                    <td className="ta-right">
                      {FormatMiles(totales.opt_minimo, 0)}
                    </td>
                    <td className="ta-right">
                      {FormatMiles(totales.inventario, 0)}
                    </td>
                    <td className="ta-right">
                      {FormatMiles(totales.dif_maxima, 0)}
                    </td>
                    <td className="ta-right">
                      {FormatMiles(totales.dif_minima, 0)}
                    </td>
                    <td className="ta-center">
                      {FormatMoney(totales.rotacion, 2)}
                    </td>
                    <td className="ta-center">
                      {FormatMoney(totales.dias_inventario, 2)}
                    </td>
                    <td className="ta-right">
                      {FormatMiles(totales.inventariomes, 0)}
                    </td>
                    <td className="ta-right">
                      {FormatMiles(totales.dif_maxima_mes, 0)}
                    </td>
                    <td className="ta-right">
                      {FormatMiles(totales.dif_minima_mes, 0)}
                    </td>
                    {/* <td className="ta-center">{FormatMiles(totales.rotacionmes, 2)}</td> */}
                  </tr>
                )}

                {rotacion && (
                  <tr>
                    <td className="celda-vendedor">
                      {capitalizePalabras(rotacion.linea)}
                    </td>
                    <td className="ta-center">
                      {rotacion.minimo === 0 ? "" : rotacion.minimo}{" "}
                    </td>
                    <td className="ta-center">
                      {rotacion.maximo === 0 ? "" : rotacion.maximo}
                    </td>
                    <td className="ta-right">
                      {rotacion.venta === 0 ? "" : rotacion.venta}
                    </td>
                    <td className="ta-right">
                      {rotacion.costo === 0 ? "" : rotacion.costo}
                    </td>
                    <td className="ta-right">
                      {rotacion.opt_maximo === 0 ? "" : rotacion.opt_maximo}
                    </td>
                    <td className="ta-right">
                      {rotacion.opt_minimo === 0 ? "" : rotacion.opt_minimo}
                    </td>
                    <td className="ta-right">
                      {rotacion.inventario === 0 ? "" : rotacion.inventario}
                    </td>
                    <td className="ta-right">
                      {rotacion.dif_maxima === 0 ? "" : rotacion.dif_maxima}
                    </td>
                    <td className="ta-right">
                      {rotacion.dif_minima === 0 ? "" : rotacion.dif_minima}
                    </td>
                    <td className="ta-center">
                      {rotacion.rotacion === 0 ? "" : rotacion.rotacion}
                    </td>
                    <td className="ta-center">
                      {rotacion.rotacion === 0 ? "" : rotacion.dias_inventario}
                    </td>
                    <td className="ta-right">
                      {rotacion.inventariomes === 0
                        ? ""
                        : rotacion.inventariomes}
                    </td>
                    <td className="ta-right">
                      {rotacion.dif_maxima_mes === 0
                        ? ""
                        : rotacion.dif_maxima_mes}
                    </td>
                    <td className="ta-right">
                      {rotacion.dif_minima_mes === 0
                        ? ""
                        : rotacion.dif_minima_mes}
                    </td>
                    {/* <td className="ta-center">{rotacion.rotacionmes === 0 ? "" : FormatMiles(rotacion.rotacionmes, 2)}</td> */}
                  </tr>
                )}
              </tfoot>
            </table>
          </div>
        </div>
      )}
    </PlantillaScreen>
  );
};
